import {
    FETCH_PRICES, FETCH_PRICES_SUCCESS, FETCH_PRICES_FAILURE,
    SAVE_PRICES, SAVE_PRICES_SUCCESS, SAVE_PRICES_FAILURE,
    EMPTY_PRICES, SET_PRICES
} from './constants';

const initialState = {
    all: [],
    isFetching: false,
    isSaving: false,
    error: {},
    saveError: {}
};

function pricesReducer(state = initialState, action) {
    switch(action.type) {
        case EMPTY_PRICES:
            return initialState;
        case FETCH_PRICES:
            return Object.assign({}, state, {
                isFetching: true,
                error: {}
            });
        case FETCH_PRICES_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                all: action.data
            });
        case FETCH_PRICES_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error
            });
        case SAVE_PRICES:
            return Object.assign({}, state, {
                isSaving: true,
                saveError: {}
            });
        case SAVE_PRICES_SUCCESS:
            return Object.assign({}, state, {
                isSaving: false,
                all: action.data
            });
        case SAVE_PRICES_FAILURE:
            return Object.assign({}, state, {
                isSaving: false,
                saveError: action.error
            });
        case SET_PRICES:
            return Object.assign({}, state, {
                all: action.data
            });
        default:
            return state;
    }
}

export default pricesReducer;



// WEBPACK FOOTER //
// ./src/containers/PricesPage/store/reducers.js